import {
  getMeetingSignDataList,
  reqCompanyInfo,
  getApplyFormList,
  getOperatorInfo } from '../services';

export default {
  namespace: 'meetingSign',
  state: {
    meetingSignData:{},
    loginPersonInfo:{},
    applyFormData:{},
    companyInfo: {},
  },
  effects: {
    * getMeetingSignData ({ payload }, { call, put }) {
      const result = yield call(getMeetingSignDataList, payload);
      yield put({
        type: 'update',
        payload: {
          meetingSignData: result,
        },
      });
    },
    * getApplyFormData ({ payload }, { call, put }) {
      const result = yield call(getApplyFormList, payload);
      yield put({
        type: 'update',
        payload: {
          applyFormData: result,
        },
      });
    },
    * getLoginpersonInfo ({ payload }, { call, put }) {
      const result = yield call(getOperatorInfo, payload);
      yield put({
        type: 'update',
        payload: {
          loginPersonInfo: result,
        },
      });
    },
  },
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
